import { PspContext } from "@/config/contexts";
import { useIsTablet } from "@/config/hooks";
import { useContext } from "react";

export function useTotpSecret() {
  const { lang } = useContext(PspContext);
  const isTablet = useIsTablet();

  return { lang, isTablet };
}
